import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const PortalEmbedPage = ({ path, title, seoTitle, description }) => (
  <div className="min-h-screen bg-white flex flex-col">
    <SEO title={seoTitle} description={description} canonical={`https://impactasportal.com${path}`} />
    <Header />
    <main className="flex-1 pt-20">
      <div className="w-full h-[calc(100vh-80px)]">
        <iframe
          src={`https://impactasportal.com${path}?embed=true`}
          title={`${title} - Impact AS Plus`}
          className="w-full h-full border-0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          data-testid="portal-embed-iframe"
        />
      </div>
    </main>
  </div>
);

export default PortalEmbedPage;
